import { render, staticRenderFns } from "./OrderInfoHeader.vue?vue&type=template&id=56fcde37&scoped=true&"
import script from "./OrderInfoHeader.vue?vue&type=script&lang=js&"
export * from "./OrderInfoHeader.vue?vue&type=script&lang=js&"
import style0 from "./OrderInfoHeader.vue?vue&type=style&index=0&id=56fcde37&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fcde37",
  null
  
)

export default component.exports